import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "kt_trainer_list",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header bg-primary text-light",
  id: "kt_trainer_list_header"
}, [
  /*#__PURE__*/_createElementVNode("h3", {
    class: "card-title fw-bolder text-light",
    style: {"font-size":"1.35rem !important"}
  }, " Edit Assesor Info "),
  /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "button",
      class: "btn btn-sm btn-icon btn-active-primary-light me-n5",
      id: "kt_drawer_assessor_list_close"
    }, [
      /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" })
    ])
  ])
], -1)
const _hoisted_3 = {
  class: "card-body position-relative",
  id: "kt_trainer_list_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_trainer_list_body",
  "data-kt-scroll-dependencies": "#kt_trainer_list_header, #kt_trainer_list_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_4 = { class: "position-relative" }
const _hoisted_5 = { class: "card-body p-2" }
const _hoisted_6 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_trainer_list_scroll"
}
const _hoisted_7 = { class: "card mb-5 mb-xl-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-secondary",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#employee_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "text-dark fw-bolder m-0" }, " Assessor Information ")
  ])
], -1)
const _hoisted_9 = {
  id: "employee_information",
  class: "collapse show"
}
const _hoisted_10 = { class: "collapse show" }
const _hoisted_11 = { class: "card-body border-top p-9" }
const _hoisted_12 = { class: "row d-flex" }
const _hoisted_13 = { class: "col-md-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Employee Image", -1)
const _hoisted_15 = { id: "preview" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "col-md-9" }
const _hoisted_19 = { class: "row mt-3 d-flex" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name", -1)
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Passport")
], -1)
const _hoisted_24 = { class: "row mt-3 d-flex" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Father's Name", -1)
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Mother's Name", -1)
const _hoisted_29 = { class: "row mb-0 d-flex" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Date of birth", -1)
const _hoisted_34 = { class: "col-4" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "National ID")
], -1)
const _hoisted_36 = { class: "col-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Birth Registration Number")
], -1)
const _hoisted_38 = { class: "row mt-3" }
const _hoisted_39 = { class: "col-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Gender")
], -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, " Select gender ", -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("option", { value: "Male" }, "Male", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("option", { value: "Female" }, "Female", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("option", { value: "Other" }, "Other", -1)
const _hoisted_45 = { class: "col-4" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Name", -1)
const _hoisted_47 = { class: "col-4" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("span", null, "Passport")
], -1)
const _hoisted_49 = { class: "row mt-3" }
const _hoisted_50 = { class: "col-md-4" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold form-label required" }, "Email", -1)
const _hoisted_52 = { class: "col-md-4" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Driving License")
], -1)
const _hoisted_54 = { class: "col-md-4" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Religion", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, " Select Religion ", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("option", { value: "Islam" }, "Islam", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("option", { value: "Hindu" }, "Hindu", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("option", { value: "Christian" }, "Christian", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("option", { value: "Buddhist" }, "Buddhist", -1)
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-md-4" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mother Name")
], -1)
const _hoisted_64 = { class: "col-md-4" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Mobile")
], -1)
const _hoisted_66 = { class: "col-md-4" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Father Name")
], -1)
const _hoisted_68 = { class: "row mt-3" }
const _hoisted_69 = { class: "col-md-8" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present Address")
], -1)
const _hoisted_71 = { class: "col-md-4" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Present District")
], -1)
const _hoisted_73 = ["label", "value"]
const _hoisted_74 = { class: "row mt-3" }
const _hoisted_75 = { class: "col-md-8" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent Address")
], -1)
const _hoisted_77 = { class: "col-md-4" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Permanent District")
], -1)
const _hoisted_79 = ["label", "value"]
const _hoisted_80 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#nid-verification",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Educational Information")
  ])
], -1)
const _hoisted_82 = {
  id: "educational_info",
  class: "collapse show"
}
const _hoisted_83 = { class: "collapse show" }
const _hoisted_84 = { class: "card-body border-top p-9" }
const _hoisted_85 = { class: "table" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Institute Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Level of Education"),
    /*#__PURE__*/_createElementVNode("th", null, "subject"),
    /*#__PURE__*/_createElementVNode("th", null, "Passing Year")
  ])
], -1)
const _hoisted_87 = ["onUpdate:modelValue"]
const _hoisted_88 = ["onUpdate:modelValue"]
const _hoisted_89 = ["onUpdate:modelValue"]
const _hoisted_90 = ["onUpdate:modelValue"]
const _hoisted_91 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus text-light" }, null, -1)
const _hoisted_92 = [
  _hoisted_91
]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus text-light" }, null, -1)
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#professional_info",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Professional Information")
  ])
], -1)
const _hoisted_97 = {
  id: "professional_info",
  class: "collapse show"
}
const _hoisted_98 = { class: "collapse show" }
const _hoisted_99 = { class: "card-body border-top p-9" }
const _hoisted_100 = { class: "table" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Designation"),
    /*#__PURE__*/_createElementVNode("th", null, "Organization"),
    /*#__PURE__*/_createElementVNode("th", null, "Address"),
    /*#__PURE__*/_createElementVNode("th", null, "Experience From"),
    /*#__PURE__*/_createElementVNode("th", null, "Experience To"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_102 = ["onUpdate:modelValue"]
const _hoisted_103 = ["onUpdate:modelValue"]
const _hoisted_104 = ["onUpdate:modelValue"]
const _hoisted_105 = ["onUpdate:modelValue"]
const _hoisted_106 = ["onUpdate:modelValue"]
const _hoisted_107 = { style: {"min-width":"100px"} }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus text-light" }, null, -1)
const _hoisted_109 = [
  _hoisted_108
]
const _hoisted_110 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus text-light" }, null, -1)
const _hoisted_111 = [
  _hoisted_110
]
const _hoisted_112 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#certificates",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Certificates List")
  ])
], -1)
const _hoisted_114 = {
  id: "certificates",
  class: "collapse show"
}
const _hoisted_115 = { class: "collapse show" }
const _hoisted_116 = { class: "card-body border-top p-9" }
const _hoisted_117 = { class: "table" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Certificate Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Organization Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Year"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_119 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus text-light" }, null, -1)
const _hoisted_120 = [
  _hoisted_119
]
const _hoisted_121 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-minus text-light" }, null, -1)
const _hoisted_122 = [
  _hoisted_121
]
const _hoisted_123 = { class: "card mb-5 mb-xl-10" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#trainer_information",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, " Assessor Training Specification ")
  ])
], -1)
const _hoisted_125 = {
  id: "trainer_information",
  class: "collapse show"
}
const _hoisted_126 = { class: "collapse show" }
const _hoisted_127 = { class: "card-body border-top p-9" }
const _hoisted_128 = { class: "row mt-3" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-4-light" }, "BTEB Certification", -1)
const _hoisted_130 = { class: "col-md-3 mt-3" }
const _hoisted_131 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is BTEB Registered? ", -1)
const _hoisted_133 = { class: "col-md-3" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Skill Level")
], -1)
const _hoisted_135 = { class: "col-md-3" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Occupation")
], -1)
const _hoisted_137 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_138 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "BTEB Registration Number", -1)
const _hoisted_139 = { class: "row mt-3" }
const _hoisted_140 = { class: "col-md-6" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Pedagogy Level Achieved")
], -1)
const _hoisted_142 = { class: "col-md-6" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Which Pedagogy Part Completed?")
], -1)
const _hoisted_144 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, " Select Pedagogy Part ", -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("option", { value: "trainer" }, "Trainer", -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("option", { value: "assessor" }, "Assessor", -1)
const _hoisted_147 = { class: "row mt-4" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("h4", { class: "fw-bold-light" }, "NSDA Certification", -1)
const _hoisted_149 = { class: "col-md-3 mt-3" }
const _hoisted_150 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_151 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label fw-bold" }, " Is the Trainer NSDA Certified? ", -1)
const _hoisted_152 = { class: "col-md-3" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Skill Level")
], -1)
const _hoisted_154 = { class: "col-md-3" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Occupation")
], -1)
const _hoisted_156 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_157 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "NSDA Registration Number", -1)
const _hoisted_158 = { class: "row mt-3" }
const _hoisted_159 = { class: "col-md-6" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Pedagogy Level Achieved")
], -1)
const _hoisted_161 = { class: "col-md-6" }
const _hoisted_162 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Which Pedagogy Part Completed?")
], -1)
const _hoisted_163 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: "",
  selected: ""
}, " Select Pedagogy Part ", -1)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("option", { value: "trainer" }, "Trainer", -1)
const _hoisted_165 = /*#__PURE__*/_createElementVNode("option", { value: "assessor" }, "Assessor", -1)
const _hoisted_166 = { class: "row-mt-6" }
const _hoisted_167 = { class: "col-md-4 mt-3" }
const _hoisted_168 = /*#__PURE__*/_createElementVNode("label", { class: "align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Area of Expertise")
], -1)
const _hoisted_169 = {
  class: "card-footer py-5 text-center",
  id: "kt_trainer_list_footer"
}
const _hoisted_170 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_drawer_assessor_list_close",
  class: "btn btn-secondary me-5"
}, " Discard ", -1)
const _hoisted_171 = ["data-kt-indicator"]
const _hoisted_172 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_173 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_174 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_175 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    id: "kt_drawer_assessor_list",
    "data-kt-drawer": "true",
    "data-kt-drawer-activate": "true",
    "data-kt-drawer-name": "trainer_list",
    "data-kt-drawer-overlay": "true",
    "data-kt-drawer-direction": "end",
    "data-kt-drawer-toggle": "#kt_drawer_assessor_list_button",
    "data-kt-drawer-close": "#kt_drawer_assessor_list_close",
    "data-kt-drawer-width": "80.5vw"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_form, {
              onSubmit: _cache[42] || (_cache[42] = _withModifiers(($event: any) => (_ctx.formSubmit()), ["prevent"])),
              model: _ctx.formData,
              rules: _ctx.rules,
              ref: "formRef"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _hoisted_14,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.file_name,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.file_name) = $event)),
                                  ref: "fileInput",
                                  accept: "image/jpeg",
                                  onChange: _ctx.updatePhoto,
                                  type: "file",
                                  class: "form-control"
                                }, null, 8, ["modelValue", "onChange"]),
                                _createElementVNode("div", _hoisted_15, [
                                  (_ctx.url)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _ctx.url
                                      }, null, 8, _hoisted_16))
                                    : (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: 
                                  this.formData?.attach_file_info?.file_path
                                    ? _ctx.api_url +
                                      this.formData?.attach_file_info?.file_path
                                    : 'media/avatars/institution-icon.png'
                                
                                      }, null, 8, _hoisted_17))
                                ]),
                                _createVNode(_component_ErrorMessage, {
                                  name: "entity_logo",
                                  class: "fv-plugins-message-container invalid-feedback"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("div", _hoisted_20, [
                                    _hoisted_21,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.formData.employee_info.name,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.employee_info.name) = $event)),
                                      type: "text",
                                      name: "name",
                                      class: "form-control form-control-sm",
                                      rows: "3"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      name: "name",
                                      class: "fv-plugins-message-container invalid-feedback"
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_22, [
                                    _hoisted_23,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.formData.employee_info.passport,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.employee_info.passport) = $event)),
                                      name: "passport",
                                      class: "form-control form-control-sm",
                                      value: "",
                                      disabled: ""
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("div", _hoisted_25, [
                                    _hoisted_26,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.formData.employee_info.father_name,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.employee_info.father_name) = $event)),
                                      type: "text",
                                      name: "father_name",
                                      class: "form-control form-control-sm",
                                      rows: "3"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      name: "father_name",
                                      class: "fv-plugins-message-container invalid-feedback"
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_27, [
                                    _hoisted_28,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.formData.employee_info.mother_name,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.employee_info.mother_name) = $event)),
                                      type: "text",
                                      name: "mother_name",
                                      class: "form-control form-control-sm",
                                      rows: "3"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      name: "mother_name",
                                      class: "fv-plugins-message-container invalid-feedback"
                                    })
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _hoisted_33,
                                    _createVNode(_component_el_form_item, {
                                      prop: "date",
                                      class: "mb-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_date_picker, {
                                          modelValue: _ctx.formData.employee_info.dob,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.employee_info.dob) = $event)),
                                          "value-format": "YYYY-MM-DD",
                                          format: "DD-MM-YYYY",
                                          type: "date",
                                          name: "dob",
                                          style: {"width":"100%"}
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_34, [
                                    _hoisted_35,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.formData.employee_info.nid,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.employee_info.nid) = $event)),
                                      readonly: "",
                                      name: "nid",
                                      class: "form-control form-control-sm bg-secondary",
                                      type: "number"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_36, [
                                    _hoisted_37,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.formData.employee_info.bcn,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.employee_info.bcn) = $event)),
                                      readonly: "",
                                      name: "bcn",
                                      class: "form-control form-control-sm bg-secondary",
                                      value: "",
                                      type: "number"
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("div", _hoisted_39, [
                                    _hoisted_40,
                                    _createVNode(_component_Field, {
                                      name: "gender",
                                      modelValue: _ctx.formData.employee_info.gender,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.employee_info.gender) = $event)),
                                      class: "form-select form-select-lg",
                                      "data-control": "select2",
                                      "data-placeholder": "Select...",
                                      "data-allow-clear": "true",
                                      "data-hide-search": "true",
                                      as: "select"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_41,
                                        _hoisted_42,
                                        _hoisted_43,
                                        _hoisted_44
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      name: "gender",
                                      class: "fv-plugins-message-container invalid-feedback"
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_45, [
                                    _hoisted_46,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.formData.employee_info.name,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.employee_info.name) = $event)),
                                      type: "text",
                                      name: "name",
                                      class: "form-control form-control-sm",
                                      rows: "3"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      name: "name",
                                      class: "fv-plugins-message-container invalid-feedback"
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_47, [
                                    _hoisted_48,
                                    _createVNode(_component_Field, {
                                      readonly: "",
                                      modelValue: _ctx.formData.employee_info.passport,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.employee_info.passport) = $event)),
                                      name: "passport",
                                      class: "form-control form-control-sm bg-secondary",
                                      value: ""
                                    }, null, 8, ["modelValue"])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("div", _hoisted_50, [
                                    _hoisted_51,
                                    _createVNode(_component_Field, {
                                      disabled: "",
                                      modelValue: _ctx.formData.employee_info.email,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.employee_info.email) = $event)),
                                      name: "EmployeeEmail",
                                      class: "form-control form-control-sm",
                                      type: "email"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      name: "EmployeeEmail",
                                      class: "fv-plugins-message-container invalid-feedback"
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_52, [
                                    _hoisted_53,
                                    _createVNode(_component_Field, {
                                      modelValue: 
                                    _ctx.formData.employee_info.driving_license
                                  ,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((
                                    _ctx.formData.employee_info.driving_license
                                  ) = $event)),
                                      name: "driving_license",
                                      class: "form-control form-control-sm",
                                      value: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_54, [
                                    _hoisted_55,
                                    _createVNode(_component_Field, {
                                      name: "religion",
                                      modelValue: _ctx.formData.employee_info.religion,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.employee_info.religion) = $event)),
                                      class: "form-select",
                                      style: {"height":"40px","width":"100%"},
                                      "data-control": "select2",
                                      "data-placeholder": "Select...",
                                      "data-allow-clear": "true",
                                      "data-hide-search": "true",
                                      as: "select"
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_56,
                                        _hoisted_57,
                                        _hoisted_58,
                                        _hoisted_59,
                                        _hoisted_60
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      name: "religion",
                                      class: "fv-plugins-message-container invalid-feedback"
                                    })
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, [
                                _hoisted_63,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formData.employee_info.mother_name,
                                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.employee_info.mother_name) = $event)),
                                  name: "mother_name",
                                  class: "form-control form-control-sm",
                                  value: ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_ErrorMessage, {
                                  name: "Mother Name",
                                  class: "fv-plugins-message-container invalid-feedback"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_64, [
                                _hoisted_65,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formData.employee_info.mobile,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.employee_info.mobile) = $event)),
                                  name: "mobile",
                                  class: "form-control form-control-sm",
                                  value: ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_ErrorMessage, {
                                  name: "mobile",
                                  class: "fv-plugins-message-container invalid-feedback"
                                })
                              ]),
                              _createElementVNode("div", _hoisted_66, [
                                _hoisted_67,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formData.employee_info.father_name,
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.employee_info.father_name) = $event)),
                                  name: "father_name",
                                  class: "form-control form-control-sm",
                                  value: ""
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_ErrorMessage, {
                                  name: "Father Name",
                                  class: "fv-plugins-message-container invalid-feedback"
                                })
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_68, [
                              _createElementVNode("div", _hoisted_69, [
                                _hoisted_70,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formData.employee_info.present_address,
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.employee_info.present_address) = $event)),
                                  name: "present_address",
                                  class: "form-control form-control-sm"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_71, [
                                _hoisted_72,
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select-solid custom-form-control",
                                  placeholder: "Select Present District",
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.employee_info.present_district) = $event)),
                                  style: {"width":"100%"},
                                  filterable: ""
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: district.id,
                                      label: district.district_name_eng,
                                      value: district.id
                                    }, _toDisplayString(district.district_name_eng), 9, _hoisted_73))
                                  }), 128)),
                                  _createTextVNode(" > ")
                                ], 512), [
                                  [_vModelSelect, _ctx.formData.employee_info.present_district]
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_74, [
                              _createElementVNode("div", _hoisted_75, [
                                _hoisted_76,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formData.employee_info.permanent_address,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.employee_info.permanent_address) = $event)),
                                  name: "permanent_address",
                                  id: "permanent_address",
                                  rows: "10",
                                  autocomplete: "off",
                                  class: "form-control"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_77, [
                                _hoisted_78,
                                _withDirectives(_createElementVNode("select", {
                                  class: "form-select-solid custom-form-control",
                                  placeholder: "Select Permanent District",
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((
                                _ctx.formData.employee_info.permanent_district
                              ) = $event)),
                                  name: "permanent_district",
                                  style: {"width":"100%"},
                                  filterable: ""
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.empDistricts, (district) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: district.id,
                                      label: district.district_name_eng,
                                      value: district.id
                                    }, _toDisplayString(district.district_name_eng), 9, _hoisted_79))
                                  }), 128))
                                ], 512), [
                                  [_vModelSelect, 
                                _ctx.formData.employee_info.permanent_district
                              ]
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_80, [
                      _hoisted_81,
                      _createElementVNode("div", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createElementVNode("div", _hoisted_84, [
                            _createElementVNode("table", _hoisted_85, [
                              _hoisted_86,
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educational_details, (data, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((
                                    _ctx.educational_details[index].institute_name
                                  ) = $event),
                                        name: "education_details",
                                        class: "form-control form-control-sm"
                                      }, null, 8, _hoisted_87), [
                                        [_vModelText, 
                                    _ctx.educational_details[index].institute_name
                                  ]
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((
                                    _ctx.educational_details[index].level_of_education
                                  ) = $event),
                                        name: "educational_details",
                                        class: "form-control form-control-sm"
                                      }, null, 8, _hoisted_88), [
                                        [_vModelText, 
                                    _ctx.educational_details[index].level_of_education
                                  ]
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.educational_details[index].subject) = $event),
                                        name: "education_details",
                                        class: "form-control form-control-sm"
                                      }, null, 8, _hoisted_89), [
                                        [_vModelText, _ctx.educational_details[index].subject]
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((
                                    _ctx.educational_details[index].passing_year
                                  ) = $event),
                                        name: "education_details",
                                        class: "form-control form-control-sm"
                                      }, null, 8, _hoisted_90), [
                                        [_vModelText, 
                                    _ctx.educational_details[index].passing_year
                                  ]
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      (index == _ctx.educational_details.length - 1)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.addEducation && _ctx.addEducation(...args))),
                                            class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                          }, _hoisted_92))
                                        : _createCommentVNode("", true),
                                      (
                                    !_ctx.educational_details[index].institute_name
                                  )
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            type: "button",
                                            onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.removeEducation && _ctx.removeEducation(...args))),
                                            class: "btn btn-icon btn-bg-danger btn-active-color-danger btn-sm me-1"
                                          }, _hoisted_94))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_95, [
                      _hoisted_96,
                      _createElementVNode("div", _hoisted_97, [
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _createElementVNode("table", _hoisted_100, [
                              _hoisted_101,
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.professional_details, (data, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((
                                    _ctx.professional_details[index].designation
                                  ) = $event),
                                        name: "education_details",
                                        class: "form-control form-control-sm"
                                      }, null, 8, _hoisted_102), [
                                        [_vModelText, 
                                    _ctx.professional_details[index].designation
                                  ]
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((
                                    _ctx.professional_details[index].organization
                                  ) = $event),
                                        name: "professional_details",
                                        class: "form-control form-control-sm"
                                      }, null, 8, _hoisted_103), [
                                        [_vModelText, 
                                    _ctx.professional_details[index].organization
                                  ]
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.professional_details[index].address) = $event),
                                        name: "education_details",
                                        class: "form-control form-control-sm"
                                      }, null, 8, _hoisted_104), [
                                        [_vModelText, _ctx.professional_details[index].address]
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.professional_details[index].exp_from) = $event),
                                        name: "education_details",
                                        class: "form-control form-control-sm"
                                      }, null, 8, _hoisted_105), [
                                        [_vModelText, _ctx.professional_details[index].exp_from]
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.professional_details[index].exp_to) = $event),
                                        name: "education_details",
                                        class: "form-control form-control-sm"
                                      }, null, 8, _hoisted_106), [
                                        [_vModelText, _ctx.professional_details[index].exp_to]
                                      ])
                                    ]),
                                    _createElementVNode("td", _hoisted_107, [
                                      (
                                    index == _ctx.professional_details.length - 1
                                  )
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.addProfession && _ctx.addProfession(...args))),
                                            class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                          }, _hoisted_109))
                                        : _createCommentVNode("", true),
                                      (
                                    !_ctx.professional_details[index].designation
                                  )
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            type: "button",
                                            onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.removeProfession && _ctx.removeProfession(...args))),
                                            class: "btn btn-icon btn-bg-danger btn-active-color-danger btn-sm me-1"
                                          }, _hoisted_111))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_112, [
                      _hoisted_113,
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("div", _hoisted_115, [
                          _createElementVNode("div", _hoisted_116, [
                            _createElementVNode("table", _hoisted_117, [
                              _hoisted_118,
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificates, (data, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_Field, {
                                        modelValue: _ctx.certificates[index].certificate_name,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.certificates[index].certificate_name) = $event),
                                        name: `certificates[${index}].certificate_name`,
                                        class: "form-control form-control-sm"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_Field, {
                                        modelValue: 
                                    _ctx.certificates[index].organization_name
                                  ,
                                        "onUpdate:modelValue": ($event: any) => ((
                                    _ctx.certificates[index].organization_name
                                  ) = $event),
                                        name: `certificates[${index}].organization_name`,
                                        class: "form-control form-control-sm"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_Field, {
                                        modelValue: _ctx.certificates[index].year,
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.certificates[index].year) = $event),
                                        name: `certificates[${index}].year`,
                                        class: "form-control form-control-sm"
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                                    ]),
                                    _createElementVNode("td", null, [
                                      (index == _ctx.certificates.length - 1)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.addcertificate && _ctx.addcertificate(...args))),
                                            class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                          }, _hoisted_120))
                                        : _createCommentVNode("", true),
                                      (!_ctx.certificates[index].certificate_name)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            type: "button",
                                            onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.removecertificate && _ctx.removecertificate(...args))),
                                            class: "btn btn-icon btn-bg-danger btn-active-color-danger btn-sm me-1"
                                          }, _hoisted_122))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_123, [
                      _hoisted_124,
                      _createElementVNode("div", _hoisted_125, [
                        _createElementVNode("div", _hoisted_126, [
                          _createElementVNode("div", _hoisted_127, [
                            _createElementVNode("div", _hoisted_128, [
                              _hoisted_129,
                              _createElementVNode("div", _hoisted_130, [
                                _createElementVNode("label", _hoisted_131, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.btbCheckStatus) = $event)),
                                    type: "checkbox",
                                    name: "is_bteb_registered",
                                    class: "form-check-input",
                                    "true-value": "yes",
                                    "false-value": "no",
                                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.bteb_registered($event)))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.btbCheckStatus]
                                  ]),
                                  _hoisted_132
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_133, [
                                _hoisted_134,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formData.skill_level_bteb,
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.skill_level_bteb) = $event)),
                                  name: "skill_level_bteb",
                                  class: "form-control form-control-sm"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_135, [
                                _hoisted_136,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formData.occupation_bteb,
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData.occupation_bteb) = $event)),
                                  name: "occupation_bteb",
                                  class: "form-control form-control-sm"
                                }, null, 8, ["modelValue"])
                              ]),
                              (this.btbCheck)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_137, [
                                    _hoisted_138,
                                    _createVNode(_component_Field, {
                                      type: "text",
                                      modelValue: _ctx.formData.bteb_registration_number,
                                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData.bteb_registration_number) = $event)),
                                      name: "bteb_registration_number",
                                      class: "form-control form-control-sm",
                                      rows: "3"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      name: "bteb_registration_number",
                                      class: "fv-plugins-message-container invalid-feedback"
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_139, [
                              _createElementVNode("div", _hoisted_140, [
                                _hoisted_141,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formData.pedagogy_level_bteb,
                                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData.pedagogy_level_bteb) = $event)),
                                  name: "pedagogy_level_bteb",
                                  class: "form-control form-control-sm"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_142, [
                                _hoisted_143,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formData.pedagogy_part_achieved_bteb,
                                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.pedagogy_part_achieved_bteb) = $event)),
                                  name: "pedagogy_part_achieved_bteb",
                                  class: "form-select",
                                  style: {"height":"40px","width":"100%"},
                                  "data-control": "select2",
                                  "data-placeholder": "Select...",
                                  "data-allow-clear": "true",
                                  "data-hide-search": "true",
                                  as: "select"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_144,
                                    _hoisted_145,
                                    _hoisted_146
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_147, [
                              _hoisted_148,
                              _createElementVNode("div", _hoisted_149, [
                                _createElementVNode("label", _hoisted_150, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.nsdCheckStatus) = $event)),
                                    type: "checkbox",
                                    class: "form-check-input",
                                    name: "is_nsda_certified",
                                    "true-value": "yes",
                                    "false-value": "no",
                                    onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.nsda_certified($event)))
                                  }, null, 512), [
                                    [_vModelCheckbox, _ctx.nsdCheckStatus]
                                  ]),
                                  _hoisted_151
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_152, [
                                _hoisted_153,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formData.skill_level_nsda,
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.formData.skill_level_nsda) = $event)),
                                  name: "skill_level_nsda",
                                  class: "form-control form-control-sm"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_154, [
                                _hoisted_155,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formData.occupation_nsda,
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.formData.occupation_nsda) = $event)),
                                  name: "occupation_nsda",
                                  class: "form-control form-control-sm"
                                }, null, 8, ["modelValue"])
                              ]),
                              (this.nsdCheck)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_156, [
                                    _hoisted_157,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.formData.nsda_registration_number,
                                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.formData.nsda_registration_number) = $event)),
                                      type: "text",
                                      name: "nsda_registration_number",
                                      class: "form-control form-control-sm",
                                      rows: "3"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      name: "nsda_registration_number",
                                      class: "fv-plugins-message-container invalid-feedback"
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_158, [
                              _createElementVNode("div", _hoisted_159, [
                                _hoisted_160,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formData.pedagogy_level_nsda,
                                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.formData.pedagogy_level_nsda) = $event)),
                                  name: "pedagogy_level_nsda",
                                  class: "form-control form-control-sm"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_161, [
                                _hoisted_162,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formData.pedagogy_part_achieved_nsda,
                                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.formData.pedagogy_part_achieved_nsda) = $event)),
                                  name: "pedagogy_part_achieved_nsda",
                                  class: "form-select",
                                  style: {"height":"40px","width":"100%"},
                                  "data-control": "select2",
                                  "data-placeholder": "Select...",
                                  "data-allow-clear": "true",
                                  "data-hide-search": "true",
                                  as: "select"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_163,
                                    _hoisted_164,
                                    _hoisted_165
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_166, [
                              _createElementVNode("div", _hoisted_167, [
                                _hoisted_168,
                                _createVNode(_component_Field, {
                                  modelValue: _ctx.formData.area_of_expertise,
                                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.formData.area_of_expertise) = $event)),
                                  name: "area_of_expertise",
                                  class: "form-control form-control-sm"
                                }, null, 8, ["modelValue"])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_169, [
                  _hoisted_170,
                  _createElementVNode("button", {
                    "data-kt-indicator": _ctx.loading ? 'on' : null,
                    class: "btn btn-lg btn-primary",
                    type: "submit"
                  }, [
                    (!_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_172, [
                          _createTextVNode(" Submit "),
                          _createElementVNode("span", _hoisted_173, [
                            _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_174, [
                          _createTextVNode(" Please wait... "),
                          _hoisted_175
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_171)
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}